import React from 'react';
import ClientsLiquidationsLayout from './clients-liquidations-layout';

export default class ClientsLiquidations extends React.Component<{}, {}> {
    render(){
        return(
            <ClientsLiquidationsLayout/>
        )
    }
}